import {
  LocationContact,
  UnifiedMonitoringProduct,
} from '@hakimo-ui/hakimo/types';
import { useState } from 'react';
import { SnapshotUploader } from '../../sop-workflow/escalate/SnapshotUploader';
import { RESPONDER_OPTIONS } from '../../sop-workflow/util';
import { ContactRspndr } from './ContactRspndr';
import ContactSMS from './ContactSMS';
import { VoiceCall } from './VoiceCall';

interface Props {
  contact: LocationContact;
  selectableContacts: LocationContact[];
  locationAlarmId?: string;
  alarmGroupId?: string;
  locationTenantId?: string;
  locationId?: number;
  escalationId?: string;
  product?: UnifiedMonitoringProduct;
  timestamp?: string;
  timezone?: string;
}

function ContactConnect(props: Props) {
  const {
    contact,
    selectableContacts,
    locationAlarmId,
    alarmGroupId,
    locationTenantId,
    locationId,
    escalationId,
    product,
    timestamp,
    timezone,
  } = props;
  const { name: toName, phoneNumber: toNumber, tag } = contact;

  const [showEvidenceModal, setShowEvidenceModal] = useState(false);

  const productType =
    product === UnifiedMonitoringProduct.SCAN ? 'scan' : 'remote-guarding';

  const dispatchResponder = RESPONDER_OPTIONS.find(
    (o) => o.contactTag === tag?.toLowerCase()
  )?.value;

  return (
    <div className="flex items-center justify-between py-2">
      <div>
        <div className="text-start">{toName}</div>
        <div className="flex items-center gap-2">
          <div className="text-xs">{toNumber}</div>
          {tag && (
            <div className="dark:bg-ondark-bg-2 bg-onlight-bg-2 border-onlight-line-2 dark:border-ondark-line-2 text-primary-500 dark:text-primary-400 flex cursor-pointer items-center gap-1 rounded-md border px-2 text-sm">
              {tag}
            </div>
          )}
        </div>
      </div>

      {tag === 'Rspndr' ? (
        <ContactRspndr
          locationId={locationId}
          locationAlarmId={locationAlarmId}
          locationTenantId={locationTenantId}
          toName={toName}
          toNumber={toNumber}
          escalationId={escalationId}
          product={product}
          timestamp={timestamp}
        />
      ) : (
        <div className="flex gap-2">
          <VoiceCall
            toNumber={toNumber}
            toName={toName}
            tag={tag}
            locationAlarmId={locationAlarmId}
            locationTenantId={locationTenantId}
            locationId={locationId}
            productType={productType}
            onCallEnd={
              dispatchResponder ? () => setShowEvidenceModal(true) : undefined
            }
          />
          <ContactSMS
            contact={contact}
            selectableContacts={selectableContacts}
            locationId={locationId}
            locationAlarmId={locationAlarmId}
            alarmGroupId={alarmGroupId}
            isScan={product === UnifiedMonitoringProduct.SCAN}
          />
        </div>
      )}

      {showEvidenceModal && locationAlarmId && dispatchResponder && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-4">
          <div className="w-full max-w-sm">
            <SnapshotUploader
              locationAlarmId={locationAlarmId}
              product={product}
              timezone={timezone}
              defaultSituation="dispatch"
              defaultResponder={dispatchResponder}
              lockSituation
              titleInCard
              onClose={() => setShowEvidenceModal(false)}
              onUploadSuccess={() => setShowEvidenceModal(false)}
            />
          </div>
        </div>
      )}
    </div>
  );
}

export default ContactConnect;
